var GroupModel = require('./groupModel');

/**
 * Set as the user's group collection none returned (ensure it exists).
 * Note: certain attributes here are arbitrary and if used, would be inaccurate,
 * but they aren't used.
 * If this becomes a probably, you want to fetch the user groups.
 * But with my group refactor -- could now add on server -- further refactor
 * would consolidate this on a 'user' compound endpoint.
 */


module.exports = GroupModel.extend({

    defaults: {
        groupId: 1,
        groupType: "NORMAL",
        name: "public",
        description: "all users",
        status: "PRESENT",
        creationTime: 1225080000000, // this would be arbitrary but not used
        creationUser: 1,
        email: null, // this would be arbitrary but not used
        color: null // this could be misleading ... but not used ( for actually would need to fetch ); refactor later
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/groups/publicGroupModel.js
 ** module id = 87
 ** module chunks = 0
 **/